import Vue from 'vue';

// 百分比四舍五入 保留两位有效数字
Vue.filter('percent', function(val) {
  let result = Math.round(val * 1000) / 10 + '%';
  return result;
});
// 百分比四舍五入 保留两位有效数字
Vue.filter('toFixed', function(val, num) {
  return val.toFixed(num);
});

// 个性推荐
Vue.filter('recDiffsimple', function(val) {
  switch (val) {
    case 1:
      return '基础';
    case 2:
      return '进阶';
    case 3:
      return '培优';
    default:
      return val;
  }
});
Vue.filter('recDiffWord', function(val) {
  switch (val) {
    case 1:
      return '基础题目：基础试题与经典试题；';
    case 2:
      return '进阶题目：巩固试题与真题演练；';
    case 3:
      return '培优题目：提高试题与难题练习；';
    default:
      return val;
  }
});
Vue.filter('recDiff', function(val) {
  switch (val) {
    case 1:
      return '简单';
    case 2:
      return '中等';
    case 3:
      return '难';
    default:
      return val;
  }
});

Vue.filter('quesDiff', function(val) {
  if (val >= 0.7) {
    return val + '/简单题';
  } else if (val >= 0.5) {
    return val + '/中等题';
  } else {
    return val + '/难题';
  }
});
Vue.filter('paperDiff', function(val) {
  if (val > 0.9) {
    return '易';
  } else if (val > 0.8) {
    return '较易';
  } else if (val > 0.6) {
    return '一般';
  } else if (val > 0.5) {
    return '较难';
  } else {
    return '难';
  }
});
Vue.filter('rank', function(val) {
  if (val >= 0.9) {
    return 'A';
  } else if (val >= 0.8) {
    return 'B';
  } else if (val >= 0.75) {
    return 'C';
  } else if (val >= 0.7) {
    return 'D';
  } else if (val >= 0.6) {
    return 'E';
  } else {
    return 'F';
  }
});
